import ControllerBase from './../../../../global/js/ControllerBase';
import { fromEvent } from 'rxjs';

export default class ControllerPdfListToolbar extends ControllerBase {
	/** A list of dom element references available to this component */
	private readonly componentRefs = {
		resultCount: 'resultCount',
		sortBy: 'sortBy',
	};

	protected selectReloadUrl: string;

	constructor(element: HTMLElement) {
		super(element);

		this.selectReloadUrl = this.$element.dataset.selectReloadUrl || '';

		this.registerSelectFieldEvents();
	}

	private reloadPageForParameter(name: string, value: string) {
		const url = new URL(this.selectReloadUrl);
		url.searchParams.set(name, value);
		window.location.href = url.toString();
	}

	/**
	 * Watch for changes to the results-per-page select control and trigger page reload
	 * @returns void
	 */
	private registerSelectFieldEvents(): void {
		const onResultsPerPageChange$ = fromEvent(this.$references[this.componentRefs.resultCount], 'change');
		onResultsPerPageChange$.subscribe(this.onSelectFieldChange.bind(this));

		const onResultsOrderChange$ = fromEvent(this.$references[this.componentRefs.sortBy], 'change');
		onResultsOrderChange$.subscribe(this.onSelectFieldChange.bind(this));
	}

	private onSelectFieldChange(e: Event): void {
		if (e && e.target) {
			const selectElement = <HTMLSelectElement>e.target;
			const selectedOptions = selectElement.selectedOptions;
			const name = selectElement.name;
			let value = '';

			if (selectedOptions.length > 0) {
				value = selectElement.selectedOptions.item(0)!.value;
			}

			this.reloadPageForParameter(name, value);
		}
	}
}
